import React, { useState, useEffect, useCallback } from "react";
import { Typography, Button, TextField, Grid, FormGroup } from "@mui/material";
import useStyles from "./style";
import { useFormik } from "formik";
import * as yup from "yup";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

//Api routes
import settingsApi from "Services/Settings";

const Settings = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  const userId = useSelector(
    (state) => state?.AuthReducer?.userid || ""
  );

  // States
  const [values, setValues] = useState([]);


  const handleSettings = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const data = {
      platform_fee_due: formValues?.platform_fee_due,
      demoaccount_id: demoaccount_id || "",
      
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Updated Commission settings successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik?.resetForm();
        setValues(null);
        getMasterValues();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update settings",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("settings value update api", err);
    };
    settingsApi.updatePlatformSettings({ ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      platform_fee_due: "0",
      demoaccount_id: "",
      userId: ""
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      platform_fee_due: yup
        .number()
        .typeError("Must be a number")
        .min(0, "Must be greater than or equal to 0")
        .nullable(),
    }),
    onSubmit: handleSettings,
  });

  // Get Payment Settings
  const getMasterValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const params = {};
    if (demoaccount_id) {
      params.demoaccountid = demoaccount_id;
    }
    const onSuccess = (res) => {
      //console.log("payment settings details ", res.data);

      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getPlatformSettings(params).then(onSuccess, onFailure);
  }, [demoaccount_id]);

  useEffect(() => {
    getMasterValues();
  }, [getMasterValues]);

  // Formik - Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(values)) {
      formik.setFieldValue("platform_fee_due", values?.platform_fee_due);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <Grid container className={classes.cardContainer}>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.container}
        >
          <div style={{ padding: "15px" }}>
            <Typography variant="h5">Admin Commission Settings</Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={6} lg={6} xl={6} className={classes.container}>
          {/* Platform fee */}
          <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="platform_fee_due"
              id="platform_fee_due"
              value={formik?.values?.platform_fee_due}
              defaultValue={formik?.values?.platform_fee_due}
              onChange={formik?.handleChange}
              type={"text"}
              fullWidth
              variant="outlined"
              size="small"
              label="Commission Percentage (%) "
              error={
                formik?.errors?.platform_fee_due && formik?.touched?.platform_fee_due
              }
              helperText={
                formik?.errors?.platform_fee_due &&
                formik?.touched?.platform_fee_due &&
                formik?.errors?.platform_fee_due
              }
            />
          </Grid>
 
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          xl={6}
          className={classes.container}
        ></Grid>
        <Grid item xs={12} md={6} lg={12} xl={12} className={classes.btn}>
          <Button variant="contained" onClick={formik.handleSubmit}>
            Update
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default Settings;
